import styled from "styled-components";
import { setPosition, setFlex } from "../variables/utils";

export const AppWrapper = styled.div`
  ${setPosition({ position: "fixed", top: "0", left: "0", zIndex: 1 })};
  height: 100%;
  width: 100%;
  min-height: 100vh;
  min-width: 100vw;
  overflow: hidden;
`;

export const CanvasWrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export const Scene = styled.div`
  width: 100%;
  height: auto;
`;

export const ImageContainer = styled.div`
  ${setPosition({ position: "relative" })};
  ${setFlex({})};
`;

export const Image = styled.img`
  width: 100%;
  max-width: 100%;
  display: block;
`;
